import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, from, lastValueFrom } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { HostApplicationService } from '../host-application.service';
import { IAuthService } from './auth.interface';
import { HttpRequest } from '@angular/common/http';
import { AuthenticationService } from '../../../api/api/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class EmbeddedAuthService implements IAuthService {
    userToken$: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);
    userInfo$: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);

    constructor(
        private hostApplicationService: HostApplicationService,
        private authenticationService: AuthenticationService,
    ) {
        hostApplicationService.getUserToken().then(tokenData => {
            this.userToken$.next(tokenData);
            this.updateUserInfoFromToken(tokenData);
        });
    }

    refreshToken(): Observable<any> {
        // In embedded mode, we don't refresh tokens ourselves
        // The host application manages token refresh
        return from(this.hostApplicationService.getUserToken()).pipe(
            take(1),
            map(async tokenData => {
                this.userToken$.next(tokenData);
                // this.updateUserInfoFromToken(tokenData); // QA-7901 This causes loops - userinfo update can trigger new requests that in return request update and trigger userInfo update.
                return tokenData;
            })
        );
    }

    private async updateUserInfoFromToken(token: any): Promise<void> {
        let response = await lastValueFrom(this.authenticationService.getAuthToken());
        let userInfo = {
            userId: (response as any || {}).account_id || null,
            displayName: (response as any || {}).name || 'Unknown User',
        }
        this.userInfo$.next(userInfo);
    }

    injectAuth(request: HttpRequest<any>): HttpRequest<any> {
        let token = this.userToken$.getValue();
        if (token && !request.headers.has('Authorization')) {
            request = request.clone({
                setHeaders: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                }
            });
        }
        return request;
    }
}
